// extracted by mini-css-extract-plugin
export default {"flagIcon":"common-components-controls-CountrySelectorControl-CountrySelectorControl__flagIcon--onMG4"};